export class PackageServiceBalanceDTO {
  productId: number;
  productName: string;
  quantity: number;
  qtdUsed: number;
  remainingBalance: number;
  packageBoatId: number;

  constructor() {
    this.productId = 0;
    this.productName = '';
    this.quantity = 0;
    this.qtdUsed = 0;
    this.remainingBalance = 0;
    this.packageBoatId = 0;
  }
}
